import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../common/html/element'
import { Icon } from '../../../../common/html/icon'
import { SCREEN } from '../../../../common/selectCurrencyUnit/constant'
import { useFormatCurrency } from '../../../../common/selectCurrencyUnit/useFormatCurrency'
import { Tooltip } from '../../../../common/tooltip'
import { COMPANY_TYPES, EMPTY_VALUE } from '../../../../utils/common'
import { selectCompanyInfo } from './../../../common/header/companyInfo/store/slice'
import { selectRevenue } from './../../store/slice'
import classes from './index.module.scss'

export const CompanyRevenue = () => {
  const { formatCurrencyWithUnit } = useFormatCurrency(SCREEN.SUMMARY)
  const { companyType } = useSelector(selectCompanyInfo)
  const revenue = useSelector(selectRevenue())

  const renderValue = () => {
    return formatCurrencyWithUnit({
      value: revenue.value,
      year: revenue.year,
      exchangeRateType:
        companyType === COMPANY_TYPES.BANK ? 'lastDayRate' : 'averageRate',
    })
  }

  const getTitle = () => {
    switch (companyType) {
      case COMPANY_TYPES.CORPORATE:
        return 'COMPANY_REVENUE'
      case COMPANY_TYPES.SECURITIES:
        return 'COMPANY_OPERATING_INCOME'
      case COMPANY_TYPES.BANK:
        return 'BANK_TOTAL_ASSETS'
      case COMPANY_TYPES.NON_BANK:
        return 'NON_BANK_TOTAL_ASSETS'
      case COMPANY_TYPES.LIFE_INSURANCE:
        return 'LIFE_INSURANCE_REVENUE_INSURANCE'
      case COMPANY_TYPES.NON_LIFE_INSURANCE:
        return 'NON_LIFE_INSURANCE_REVENUE_INSURANCE'
      default:
        return ''
    }
  }

  return (
    <Element
      className={classes.companyRevenue}
      style={{ borderColor: '#B5CEF8', color: '#3A414B' }}
    >
      <Translate value={`companySummary.topIndustryPlayers.${getTitle()}`} />
      &nbsp; ({revenue.year || EMPTY_VALUE}):&nbsp;{renderValue()}
      <Tooltip
        tooltipContent="companySummary.topIndustryPlayers.TOOLTIP_REVENUE"
        isI18n
        contentClass="ml1 dInline"
        tooltipContentStyle={{ maxWidth: 400 }}
      >
        <Icon
          className="icon-info-circle"
          style={{ color: '#9C9C9C', fontSize: 13 }}
        />
      </Tooltip>
    </Element>
  )
}
